<div class="certificate-container">
  <header class="certificate-header">
    <div class="certificate-icon-wrapper" aria-hidden="true">
      <i class="fas fa-certificate"></i>
    </div>
    <div class="certificate-header-copy">
      <h2 class="certificate-title" tabindex="-1" cdkFocusInitial>Propiedades de la firma</h2>
      <p class="certificate-subtitle">{{ subjectCn }}</p>
    </div>
  </header>

  <div class="certificate-body">
    <div class="certificate-details">
      <div class="info-row">
        <span class="info-label">Titular</span>
        <span class="info-value">{{ cert.titular || '—' }}</span>
      </div>
      <div class="info-row" *ngIf="subjectOrg">
        <span class="info-label">Organización</span>
        <span class="info-value">{{ subjectOrg }}</span>
      </div>
      <div class="info-row" *ngIf="subjectEmail">
        <span class="info-label">Correo</span>
        <span class="info-value">{{ subjectEmail }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">Emitido por</span>
        <span class="info-value">
          {{ issuerCn }}
          <span class="info-muted" *ngIf="issuerOrg && issuerOrg !== issuerCn"> · {{ issuerOrg }}</span>
        </span>
      </div>
      <div class="info-row" *ngIf="cert.serial && cert.serial !== 'N/A'">
        <span class="info-label">Serial</span>
        <span class="info-value info-mono">{{ cert.serial }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">Fecha de firma</span>
        <span class="info-value">{{ formatDisplayDate(cert.fechaFirma) }}</span>
      </div>
      <div class="info-row" *ngIf="cert.validoDesde && cert.validoDesde !== 'N/A'">
        <span class="info-label">Válido desde</span>
        <span class="info-value">{{ formatDisplayDate(cert.validoDesde) }}</span>
      </div>
      <div class="info-row" *ngIf="cert.validoHasta && cert.validoHasta !== 'N/A'">
        <span class="info-label">Válido hasta</span>
        <span class="info-value">{{ formatDisplayDate(cert.validoHasta) }}</span>
      </div>
    </div>

    <section class="cert-details-tsa-ltv" aria-labelledby="cert-details-tsa-ltv-heading">
      <h3 id="cert-details-tsa-ltv-heading" class="cert-details-tsa-ltv-heading">Detalles de la firma</h3>
      <p class="cert-detail-line">{{ timestampDetailText }}</p>
      <p class="cert-detail-line">{{ ltvDetailText }}</p>
      <p class="cert-detail-line" *ngIf="cert.serviceMessage && cert.success === false">{{ cert.serviceMessage }}</p>
      <p class="cert-last-check">
        <span class="cert-last-check-label">Última comprobación:</span>
        <span class="cert-last-check-value">{{ formatLastCheckDate(lastCheckDate) }}</span>
      </p>
    </section>

    <button type="button" class="btn-raw-toggle" (click)="toggleRawDn()" [attr.aria-expanded]="showRawDn">
      {{ showRawDn ? 'Ocultar DN completo' : 'Ver DN completo' }}
    </button>
    <div class="cert-raw-dn" *ngIf="showRawDn">
      <p *ngIf="cert.asunto && cert.asunto !== 'N/A'"><strong>Asunto:</strong> {{ cert.asunto }}</p>
      <p *ngIf="cert.emisor && cert.emisor !== 'N/A'"><strong>Emisor:</strong> {{ cert.emisor }}</p>
    </div>
  </div>

  <footer class="button-bar">
    <button type="button" class="btn-close" (click)="dialogRef.close()">Cerrar</button>
  </footer>
</div>
